import { render, staticRenderFns } from "./driver_page.vue?vue&type=template&id=707e51de&scoped=true"
import script from "./driver_page.vue?vue&type=script&lang=js"
export * from "./driver_page.vue?vue&type=script&lang=js"
import style0 from "./driver_page.vue?vue&type=style&index=0&id=707e51de&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707e51de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('707e51de')) {
      api.createRecord('707e51de', component.options)
    } else {
      api.reload('707e51de', component.options)
    }
    module.hot.accept("./driver_page.vue?vue&type=template&id=707e51de&scoped=true", function () {
      api.rerender('707e51de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics_hongde/logs/driver_page.vue"
export default component.exports